import { create } from "zustand";

interface LoginStoreState {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const useLoginStore = create<LoginStoreState>((set) => ({
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
}));

export default useLoginStore;